
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class DashboardItem extends Vue {

  @Prop()
  icon!: String;

  @Prop({required: false, default: ""})
  iconColor!: String;

  @Prop()
  title!: String;

  @Prop()
  subTitle!: String;

  @Prop()
  text!: String;

  @Prop({required: false})
  textHtml!: String;

  @Prop({default: false})
  readonly !: boolean;

  show() {
    this.$emit("show");
  }
}
